/* eslint-disable */
/**
 * Lightbox.js — Full-screen image viewer
 * Click image in catalog card → opens enlarged view
 * Design: Sandstone Luxury system (flat, Montserrat, var(--sandstone) accents)
 */
import React, { useEffect, useCallback } from "react";

export function Lightbox({ src, alt, onClose }) {
  // Close on ESC
  const handleKey = useCallback((e) => {
    if (e.key === "Escape") onClose();
  }, [onClose]);

  useEffect(() => {
    document.addEventListener("keydown", handleKey);
    // Prevent body scroll while lightbox is open
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", handleKey);
      document.body.style.overflow = prev;
    };
  }, [handleKey]);

  if (!src) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        background: "var(--card-bg)",
        zIndex: 'var(--z-modal-stack)',
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        animation: "clb-lb-in 0.2s ease",
      }}
    >
      {/* Global keyframes */}
      <style>{`
        @keyframes clb-lb-in { from { opacity: 0; } to { opacity: 1; } }
      `}</style>

      {/* Close button — top right */}
      <button
        onClick={onClose}
        style={{
          position: "absolute",
          top: 20,
          right: 20,
          width: 36,
          height: 36,
          background: "var(--card-bg)",
          border:"var(--border-med) solid var(--text)",
          borderRadius:'var(--radius-md)',
          color: "var(--text)",
          fontSize: 'var(--text-xl)',
          fontFamily: "'Montserrat', sans-serif",
          fontWeight: 300,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "border-color 0.15s",
          zIndex: 'calc(var(--z-modal-stack) + 1)',
        }}
        onMouseEnter={e => { e.currentTarget.style.borderColor = "var(--gold-deep)"; }}
        onMouseLeave={e => { e.currentTarget.style.borderColor = "var(--text)"; }}
      >
        ×
      </button>

      {/* ESC hint */}
      <div style={{
        position: "absolute",
        bottom: 20,
        left: "50%",
        transform: "translateX(-50%)",
        fontSize: 'var(--text-2xs)',
        letterSpacing: 2,
        textTransform: "uppercase",
        color: "var(--sandstone)",
        fontFamily: "'Montserrat', sans-serif",
        fontWeight: 'var(--weight-medium)',
      }}>
        ESC TO CLOSE
      </div>

      {/* Image */}
      <img
        src={src}
        alt={alt || ""}
        loading="lazy"
        onClick={e => e.stopPropagation()}
        style={{
          maxWidth: "90vw",
          maxHeight: "90vh",
          objectFit: "contain",
          cursor: "default",
        }}
      />
    </div>
  );
}
